<div id="modal-content-wrapper">
    <section class="modal-body">
        <p i18n  class="text" >
            Your spot for <span class="bold">{{session.title}}</span> at <span class="bold">{{session.date | date:'yyyy-MM-dd HH:mm'}}</span> has been reserved!
        </p>
    </section>
    <footer id="modal-footer">
        <button i18n mat-raised-button id="modal-action-button" (click)="closeModal()">
            Ok
        </button>
    </footer>
</div>